module.exports = __webpack_public_path__ + "bcf880e4d036b508095c5b09a5ac63b2.pdf";